// Mode présentation : la zone du document en plein écran, une page à la fois en « Page entière ».
// Clic sur la moitié gauche ou droite, flèches, Page précédente/suivante ou espace ; Échap (navigateur) :
// sortie, zoom et position restaurés.
// Bouton masqué quand le navigateur ne permet pas le plein écran d'un élément (Safari sur iPhone).

export function initialiserPresentation(section, { viewer, eventBus, ScrollMode }) {
  const bouton = section.querySelector('[data-action="presentation"]');
  const zone   = section.querySelector('.pdf-zone');
  let avant    = null;

  if (!document.fullscreenEnabled) return;

  const enPresentation = () => document.fullscreenElement === zone;

  // Largeur de la page affichée, pour placer les flèches contre ses bords (variable --demi-page du CSS)
  const placerFleches = () => {
    const page = viewer.getPageView(viewer.currentPageNumber - 1)?.div;
    if (enPresentation() && page) {
      zone.style.setProperty('--demi-page', `${page.getBoundingClientRect().width / 2}px`);
    }
  };
  eventBus.on('scalechanging', () => requestAnimationFrame(placerFleches));
  eventBus.on('pagechanging', () => requestAnimationFrame(placerFleches));

  bouton.hidden = false;
  bouton.addEventListener('click', () => {
    zone.requestFullscreen().catch((erreur) => console.error('Mode présentation :', erreur));
  });

  document.addEventListener('fullscreenchange', () => {
    if (enPresentation()) {
      avant = { zoom: viewer.currentScaleValue, defilement: viewer.scrollMode };
      const page = viewer.currentPageNumber;
      viewer.scrollMode = ScrollMode.PAGE;
      viewer.currentScaleValue = 'page-fit';
      viewer.currentPageNumber = page;
    } else if (avant) {
      const page = viewer.currentPageNumber;
      viewer.scrollMode = avant.defilement;
      viewer.currentScaleValue = avant.zoom;
      viewer.currentPageNumber = page;
      avant = null;
    }
  });

  // Moitié gauche de l'écran : page précédente ; moitié droite : page suivante (flèche au survol)
  zone.querySelector('[data-action="presentation-precedente"]').addEventListener('click', () => viewer.previousPage());
  zone.querySelector('[data-action="presentation-suivante"]').addEventListener('click', () => viewer.nextPage());

  const touches = {
    ArrowRight: () => viewer.nextPage(),
    ArrowDown:  () => viewer.nextPage(),
    PageDown:   () => viewer.nextPage(),
    ' ':        (e) => (e.shiftKey ? viewer.previousPage() : viewer.nextPage()),
    ArrowLeft:  () => viewer.previousPage(),
    ArrowUp:    () => viewer.previousPage(),
    PageUp:     () => viewer.previousPage(),
    Home:       () => { viewer.currentPageNumber = 1; },
    End:        () => { viewer.currentPageNumber = viewer.pagesCount; },
  };

  document.addEventListener('keydown', (e) => {
    if (enPresentation() && touches[e.key]) {
      e.preventDefault();
      touches[e.key](e);
    }
  });
}
